import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from '../../atoms/link/Link'
import { openUrl } from './../../utils/expo-linking'
import { BodyText, Size as BodyTextSize } from '../../atoms/bodyText/BodyText'

export type MessagingSlaDisclaimerProps = {
  contactCarePhoneNumber: string
  emergencyPhoneNumber: string
}

export const MessagingSlaDisclaimer: FunctionComponent<MessagingSlaDisclaimerProps> = ({
  contactCarePhoneNumber,
  emergencyPhoneNumber,
}) => {
  return (
    <BodyText
      size={BodyTextSize.CAPTION}
      textAlign='center'
      text={
        <FormattedMessage
          defaultMessage='Your provider will respond as soon as they can. For immediate crisis support, contact <link>{contactCarePhoneNumber}</link>, ext 2, or call <link>{emergencyPhoneNumber}</link>.'
          description='Safety notice beneath the provider list in the Messages popover.'
          values={{
            contactCarePhoneNumber,
            emergencyPhoneNumber,
            link: (phone: string) => (
              <Link size={BodyTextSize.CAPTION} text={phone} onPress={() => openUrl(`tel:${phone}`)} />
            ),
          }}
        />
      }
    />
  )
}
